import { machine, RewardsOnboardingStateValue } from './state/machine-rewards-onboarding'

/**
 * Identify whether state from Auth0 claim is valid in state machine. Exclude final state
 * and `invalid` state (used as fallback)
 */

export const isValidRewardsState = (
  state: string,
): state is Exclude<RewardsOnboardingStateValue, 'invalid'> => {
  return !!state && state !== 'invalid' && Object.keys(machine.states).includes(state)
}
